import { createI18n } from 'vue-i18n'

import en from './en'
import es from './es'
import ko from './ko'
import ru from './ru'
import vi from './vi'
import zh from './zh'
import ptPT from './pt-PT'
import ptBR from './pt-BR'

export default createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    ko,
    ru,
    vi,
    zh,
    'pt-PT': ptPT,
    'pt-BR': ptBR,
  },
})
